export default {
  producer: {
    title: "BP节点",
    list: {
      empty: "无BP节点",
      header: {
        rank: "排名",
        name: "名称",
        voteReceived: "投票节点",
        blockProducedCount: "产出区块数量",
        transactionProcessedCount: "产出交易数量"
      }
    }
  }
}
